/* CARAVIUM PLANIFICAR — finish trip escape hatch */
(function(){
'use strict';
if(!location.pathname.includes('/pages/planificar')) return;
const TRIP_KEY='caravium_ai_trip_v1';
const CHOICES_KEY='caravium_plan_selected_sleep_v2';
const ACTIVE_KEY='caravium_live_trip_active_v1';
const NOTES_KEY='caravium_plan_notes_v1';
function injectPremiumWizardStyle(){
  if(document.getElementById('cvpw-premium-panel-css'))return;
  const s=document.createElement('style');
  s.id='cvpw-premium-panel-css';
  s.textContent=`
    /* Shared premium shell */
    .cpv3[data-cvpw-step="route"] .cpv3-left,
    .cpv3[data-cvpw-step="prefs"] .cpv3-left,
    .cpv3[data-cvpw-step="sleep"] .cpv3-left,
    .cpv3[data-cvpw-step="loading"] .cvpw-loading,
    .cpv3[data-cvpw-step="summary"] .cpv3-right,
    .cpv3[data-cvpw-step="final"] .cpv3-right{
      max-width:940px!important;
      margin:0 auto!important;
      padding:30px 32px 28px!important;
      border:1px solid rgba(255,255,255,.14)!important;
      border-radius:28px!important;
      background:linear-gradient(135deg,#123b5d 0%,#1d527d 58%,#315d91 100%)!important;
      box-shadow:0 20px 52px rgba(13,27,42,.18),0 3px 10px rgba(18,59,93,.12),inset 0 1px 0 rgba(255,255,255,.12)!important;
      position:relative!important;
      overflow:hidden!important;
      box-sizing:border-box!important;
    }
    .cpv3[data-cvpw-step="route"] .cpv3-left:before,
    .cpv3[data-cvpw-step="prefs"] .cpv3-left:before,
    .cpv3[data-cvpw-step="sleep"] .cpv3-left:before,
    .cpv3[data-cvpw-step="summary"] .cpv3-right:before,
    .cpv3[data-cvpw-step="final"] .cpv3-right:before{
      content:'';position:absolute;inset:0;pointer-events:none;
      background:radial-gradient(circle at 88% 2%,rgba(255,255,255,.14),transparent 34%);
    }

    /* Form panels become clean inside the blue shell */
    .cpv3[data-cvpw-step="route"] .cpv3-card,
    .cpv3[data-cvpw-step="prefs"] .cpv3-card,
    .cpv3[data-cvpw-step="sleep"] .cpv3-card,
    .cpv3[data-cvpw-step="route"] #cvpw-sleep,
    .cpv3[data-cvpw-step="prefs"] #cvpw-sleep,
    .cpv3[data-cvpw-step="sleep"] #cvpw-sleep{
      max-width:none!important;margin:0!important;padding:0!important;
      background:transparent!important;border:0!important;box-shadow:none!important;
      position:relative!important;z-index:1!important;
    }
    .cpv3[data-cvpw-step="route"] .cpv3-card h2,
    .cpv3[data-cvpw-step="prefs"] .cpv3-card h2,
    .cpv3[data-cvpw-step="sleep"] #cvpw-sleep h2{color:#fff!important;text-shadow:0 1px 1px rgba(0,0,0,.08)!important}
    .cpv3[data-cvpw-step="route"] .cpv3-muted,
    .cpv3[data-cvpw-step="prefs"] .cpv3-muted,
    .cpv3[data-cvpw-step="sleep"] #cvpw-sleep>p{color:rgba(255,255,255,.84)!important}
    .cpv3[data-cvpw-step="route"] .cpv3-field label,
    .cpv3[data-cvpw-step="prefs"] .cpv3-field label{color:rgba(255,255,255,.96)!important;font-weight:900!important}
    .cpv3[data-cvpw-step="route"] .cpv3-field input,
    .cpv3[data-cvpw-step="route"] .cpv3-field select,
    .cpv3[data-cvpw-step="prefs"] .cpv3-field input,
    .cpv3[data-cvpw-step="prefs"] .cpv3-field select{
      background:#fff!important;border:1px solid rgba(255,255,255,.9)!important;
      box-shadow:0 5px 14px rgba(3,20,34,.12),inset 0 1px 1px rgba(13,27,42,.04)!important;
      min-height:54px!important;color:#0d1b2a!important;
    }
    .cpv3[data-cvpw-step="route"] .cpv3-field input:focus,
    .cpv3[data-cvpw-step="route"] .cpv3-field select:focus,
    .cpv3[data-cvpw-step="prefs"] .cpv3-field input:focus,
    .cpv3[data-cvpw-step="prefs"] .cpv3-field select:focus{
      border-color:#5ee7d8!important;box-shadow:0 0 0 4px rgba(94,231,216,.20),0 6px 16px rgba(3,20,34,.14)!important;outline:none!important;
    }

    /* Preferences: force readable dark text in every state */
    .cpv3[data-cvpw-step="prefs"] .cpv3-check{
      background:#fff!important;border:1px solid #d8e4e8!important;
      box-shadow:0 7px 18px rgba(3,20,34,.10)!important;
      color:#123b5d!important;
      font-weight:850!important;
    }
    .cpv3[data-cvpw-step="prefs"] .cpv3-check *{color:#123b5d!important}
    .cpv3[data-cvpw-step="prefs"] .cpv3-check:has(input:checked){
      background:#e9fbf8!important;border-color:#52d8c9!important;
      box-shadow:0 0 0 2px rgba(82,216,201,.16),0 8px 20px rgba(3,20,34,.12)!important;
      color:#0d675f!important;
    }
    .cpv3[data-cvpw-step="prefs"] .cpv3-check:has(input:checked) *{color:#0d675f!important}
    .cpv3[data-cvpw-step="prefs"] .cpv3-check input{accent-color:#14b8a6!important}

    /* Sleep cards */
    .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option{
      background:#fff!important;border-color:#d8e4e8!important;
      box-shadow:0 7px 18px rgba(3,20,34,.10)!important;color:#123b5d!important;
    }
    .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option.is-active{
      background:#e9fbf8!important;border-color:#52d8c9!important;box-shadow:0 0 0 2px rgba(82,216,201,.16),0 8px 20px rgba(3,20,34,.12)!important;
    }
    .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option strong{color:#123b5d!important}
    .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option span{color:#5e7180!important}
    .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap{
      background:rgba(255,255,255,.10)!important;border-color:rgba(255,255,255,.20)!important;
      box-shadow:inset 0 1px 0 rgba(255,255,255,.06)!important;
    }
    .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap label{color:#fff!important}
    .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap p{color:rgba(255,255,255,.80)!important}
    .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap textarea{
      background:#fff!important;border-color:rgba(255,255,255,.9)!important;color:#123b5d!important;
      box-shadow:0 6px 16px rgba(3,20,34,.12)!important;
    }

    /* Progress and navigation */
    .cpv3[data-cvpw-step="route"] #cvpw-controls,
    .cpv3[data-cvpw-step="prefs"] #cvpw-controls,
    .cpv3[data-cvpw-step="sleep"] #cvpw-controls{max-width:none!important;margin:20px 0 0!important;position:relative!important;z-index:1!important}
    .cpv3[data-cvpw-step="route"] .cvpw-progress,
    .cpv3[data-cvpw-step="prefs"] .cvpw-progress,
    .cpv3[data-cvpw-step="sleep"] .cvpw-progress{
      background:rgba(255,255,255,.10)!important;border-color:rgba(255,255,255,.18)!important;
      box-shadow:inset 0 1px 0 rgba(255,255,255,.06)!important;
    }
    .cpv3[data-cvpw-step="route"] .cvpw-label,
    .cpv3[data-cvpw-step="prefs"] .cvpw-label,
    .cpv3[data-cvpw-step="sleep"] .cvpw-label{color:#fff!important}
    .cpv3[data-cvpw-step="route"] .cvpw-count,
    .cpv3[data-cvpw-step="prefs"] .cvpw-count,
    .cpv3[data-cvpw-step="sleep"] .cvpw-count{color:#86f1e4!important}
    .cpv3[data-cvpw-step="route"] .cvpw-track,
    .cpv3[data-cvpw-step="prefs"] .cvpw-track,
    .cpv3[data-cvpw-step="sleep"] .cvpw-track{background:rgba(255,255,255,.18)!important}
    .cpv3[data-cvpw-step="route"] .cvpw-prev,
    .cpv3[data-cvpw-step="prefs"] .cvpw-prev,
    .cpv3[data-cvpw-step="sleep"] .cvpw-prev{background:#fff!important;color:#123b5d!important;box-shadow:0 6px 16px rgba(3,20,34,.10)!important}
    .cpv3[data-cvpw-step="route"] .cvpw-next,
    .cpv3[data-cvpw-step="prefs"] .cvpw-next,
    .cpv3[data-cvpw-step="sleep"] .cvpw-next{box-shadow:0 9px 22px rgba(3,20,34,.18),inset 0 1px 0 rgba(255,255,255,.16)!important}

    /* Loading screen */
    .cpv3[data-cvpw-step="loading"] .cvpw-loading{color:#fff!important;text-align:center!important}
    .cpv3[data-cvpw-step="loading"] .cvpw-loading h2,
    .cpv3[data-cvpw-step="loading"] .cvpw-loading strong{color:#fff!important}
    .cpv3[data-cvpw-step="loading"] .cvpw-loading p{color:rgba(255,255,255,.84)!important}

    /* Summary/results: same blue shell, white clean cards */
    .cpv3[data-cvpw-step="summary"] .cpv3-right,
    .cpv3[data-cvpw-step="final"] .cpv3-right{z-index:0!important}
    .cpv3[data-cvpw-step="summary"] #cvpw-summary-head,
    .cpv3[data-cvpw-step="final"] #cvpw-summary-head{
      max-width:none!important;margin:0 0 18px!important;padding:0 0 16px!important;
      background:transparent!important;border:0!important;border-bottom:1px solid rgba(255,255,255,.18)!important;border-radius:0!important;
      position:relative!important;z-index:1!important;box-shadow:none!important;
    }
    .cpv3[data-cvpw-step="summary"] #cvpw-summary-head h2,
    .cpv3[data-cvpw-step="final"] #cvpw-summary-head h2{color:#fff!important}
    .cpv3[data-cvpw-step="summary"] #cvpw-summary-head p,
    .cpv3[data-cvpw-step="final"] #cvpw-summary-head p{color:rgba(255,255,255,.84)!important}
    .cpv3[data-cvpw-step="summary"] #cpv3-plan,
    .cpv3[data-cvpw-step="final"] #cpv3-plan{max-width:none!important;margin:0!important;position:relative!important;z-index:1!important;gap:14px!important}
    .cpv3[data-cvpw-step="summary"] .cpv3-day,
    .cpv3[data-cvpw-step="final"] .cpv3-day,
    .cpv3[data-cvpw-step="summary"] .cvpw-ai-day,
    .cpv3[data-cvpw-step="final"] .cvpw-ai-day{
      background:#fff!important;border:1px solid #d9e4e9!important;border-radius:20px!important;
      box-shadow:0 8px 24px rgba(3,20,34,.10)!important;color:#173b58!important;
    }
    .cpv3[data-cvpw-step="summary"] .cpv3-day h3,
    .cpv3[data-cvpw-step="final"] .cpv3-day h3,
    .cpv3[data-cvpw-step="summary"] .cvpw-ai-day h3,
    .cpv3[data-cvpw-step="final"] .cvpw-ai-day h3{color:#173b58!important}
    .cpv3[data-cvpw-step="summary"] .cpv3-daymeta,
    .cpv3[data-cvpw-step="final"] .cpv3-daymeta,
    .cpv3[data-cvpw-step="summary"] .cvpw-ai-why,
    .cpv3[data-cvpw-step="final"] .cvpw-ai-why{color:#5f7280!important}
    .cpv3[data-cvpw-step="summary"] .cvpw-ai-activity,
    .cpv3[data-cvpw-step="final"] .cvpw-ai-activity{background:#f3f7f9!important;color:#244966!important}
    .cpv3[data-cvpw-step="summary"] .cvpw-sleep-card,
    .cpv3[data-cvpw-step="final"] .cvpw-sleep-card{
      background:#fff!important;border:1px solid #d8e3e8!important;box-shadow:none!important;
    }
    .cpv3[data-cvpw-step="summary"] .cvpw-sleep-card.is-selected,
    .cpv3[data-cvpw-step="final"] .cvpw-sleep-card.is-selected{background:#e9fbf8!important;border:2px solid #52d8c9!important}

    /* Final map and finish actions inside same visual system */
    .cpv3[data-cvpw-step="final"] .cpv3-mapcard{
      max-width:none!important;margin:0 0 18px!important;padding:16px!important;
      background:#fff!important;border:1px solid #d9e4e9!important;border-radius:20px!important;
      box-shadow:0 8px 24px rgba(3,20,34,.10)!important;position:relative!important;z-index:1!important;
    }
    .cpv3[data-cvpw-step="final"] .cpv3-maphead strong{color:#173b58!important}
    .cpv3[data-cvpw-step="final"] .cpv3-maphead span{color:#667984!important}
    .cpv3[data-cvpw-step="summary"] #cvpw-trip-end,
    .cpv3[data-cvpw-step="final"] #cvpw-trip-end{
      max-width:none!important;margin:18px 0 0!important;position:relative!important;z-index:1!important;
      background:rgba(255,255,255,.11)!important;border:1px solid rgba(255,255,255,.20)!important;
      border-radius:20px!important;box-shadow:none!important;
    }
    .cpv3[data-cvpw-step="summary"] #cvpw-trip-end h2,
    .cpv3[data-cvpw-step="summary"] #cvpw-trip-end h3,
    .cpv3[data-cvpw-step="final"] #cvpw-trip-end h2,
    .cpv3[data-cvpw-step="final"] #cvpw-trip-end h3{color:#fff!important}
    .cpv3[data-cvpw-step="summary"] #cvpw-trip-end p,
    .cpv3[data-cvpw-step="final"] #cvpw-trip-end p{color:rgba(255,255,255,.84)!important}

    @media(max-width:700px){
      .cpv3[data-cvpw-step="route"] .cpv3-left,
      .cpv3[data-cvpw-step="prefs"] .cpv3-left,
      .cpv3[data-cvpw-step="sleep"] .cpv3-left,
      .cpv3[data-cvpw-step="loading"] .cvpw-loading,
      .cpv3[data-cvpw-step="summary"] .cpv3-right,
      .cpv3[data-cvpw-step="final"] .cpv3-right{
        padding:20px 16px 18px!important;border-radius:22px!important;box-shadow:0 14px 32px rgba(13,27,42,.17)!important;
      }
      .cpv3[data-cvpw-step="route"] .cpv3-card,
      .cpv3[data-cvpw-step="prefs"] .cpv3-card,
      .cpv3[data-cvpw-step="sleep"] #cvpw-sleep{padding:0!important;border-radius:0!important}
      .cpv3[data-cvpw-step="route"] .cpv3-field input,
      .cpv3[data-cvpw-step="route"] .cpv3-field select,
      .cpv3[data-cvpw-step="prefs"] .cpv3-field input,
      .cpv3[data-cvpw-step="prefs"] .cpv3-field select{min-height:56px!important;font-size:17px!important}
      .cpv3[data-cvpw-step="route"] #cvpw-controls,
      .cpv3[data-cvpw-step="prefs"] #cvpw-controls,
      .cpv3[data-cvpw-step="sleep"] #cvpw-controls{margin-top:16px!important}
      .cpv3[data-cvpw-step="final"] .cpv3-map{height:330px!important}
      .cpv3[data-cvpw-step="summary"] .cvpw-sleep-options,
      .cpv3[data-cvpw-step="final"] .cvpw-sleep-options{grid-template-columns:1fr!important}
    }
  `;
  document.head.appendChild(s);
}
function clearTrip(){
  try{
    localStorage.removeItem(TRIP_KEY);
    localStorage.removeItem(CHOICES_KEY);
    localStorage.removeItem(ACTIVE_KEY);
    localStorage.removeItem(NOTES_KEY);
  }catch(_e){}
}
function resetForm(){
  const f=document.querySelector('#cpv3-form');
  if(!f)return;
  if(f.elements?.origen)f.elements.origen.value='';
  if(f.elements?.destino)f.elements.destino.value='';
  if(f.elements?.dias)f.elements.dias.value='3';
}
function goNewTrip(){
  clearTrip();
  const u=new URL(location.href);
  u.searchParams.set('nuevo','1');
  location.href=u.pathname+'?'+u.searchParams.toString();
}
function enhanceFinished(){
  const end=document.querySelector('#cvpw-trip-end');
  if(!end) return;
  const title=end.querySelector('h2');
  if(!title || !/viaje finalizado/i.test(title.textContent||'')) return;
  if(end.querySelector('#cvpw-new-trip')) return;
  const actions=end.querySelector('.cvpw-trip-actions');
  if(!actions) return;
  const b=document.createElement('button');
  b.type='button';
  b.id='cvpw-new-trip';
  b.className='cvpw-trip-btn cvpw-trip-primary';
  b.textContent='＋ Planificar otro viaje';
  actions.prepend(b);
  b.addEventListener('click',goNewTrip);
  const p=end.querySelector('p');
  if(p)p.textContent='El viaje ha terminado. Puedes planificar uno nuevo, reiniciar este recorrido o revisar el itinerario completo.';
}
function boot(){
  injectPremiumWizardStyle();
  const u=new URL(location.href);
  if(u.searchParams.get('nuevo')==='1'){
    clearTrip();
    setTimeout(resetForm,80);
    u.searchParams.delete('nuevo');
    history.replaceState({},'',u.pathname+(u.searchParams.toString()?('?'+u.searchParams.toString()):''));
  }
  enhanceFinished();
  new MutationObserver(enhanceFinished).observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
